import React, { useState } from 'react'

export default function CrossArrow({ color = '#FFFFFF', className }) {
    const [isHovered, setIsHovered] = useState(false);

    // Use the passed color for both states
    const currentColor = color;

    return (
        <svg
            height={16}
            width={16}
            fill="none"
            viewBox="0 0 24 24"
            className={className}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <path
                stroke={currentColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 17 17 7m0 0H8m9 0v9"
            />
        </svg>
    )
}
